import CheckEmailQuery from 'Query/CheckEmail.query';
import { QueryDispatcher } from 'Util/Request';

import { updateEmailAvailable } from './Checkout.action';

/**
 * Checkout Dispatcher
 * @class CheckoutDispatcher
 * @extends QueryDispatcher
 * @namespace Store/Checkout/Dispatcher
 *  */
export class CheckoutDispatcher extends QueryDispatcher {
    onSuccess(data, dispatch) {
        const { isEmailAvailable: { is_email_available } } = data;
        dispatch(updateEmailAvailable(is_email_available));
    }

    onError(error, dispatch) {
        dispatch(updateEmailAvailable(true));
    }

    prepareRequest(email) {
        return CheckEmailQuery.getIsEmailAvailableQuery(email);
    }
}

export default new CheckoutDispatcher();
